export const Footer = (props) => {
  return (
    <div>
      <div id="footer">
        <div className="container text-center">
          <p>&copy; 2023 NETpro. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};
